import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import {HashRouter as Router, Route, Switch} from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import LandingPage from './components/pages/LandingPage/LandingPage';
import SubscribePage from './components/pages/SubscribePage/SubscribePage';
import GamePage from './components/pages/GamePage/GamePage';
import Footer from './components/Footer/Footer'


class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowingLandingPage: true,
            isShowingGameOver: false,
            results: null
        };

        this.handleCloseLandingPage = this.handleCloseLandingPage.bind(this);
        this.handleGameOver = this.handleGameOver.bind(this);
    }

    handleCloseLandingPage() {
        this.setState({
            isShowingLandingPage: false
        });
    }

    handleGameOver(results) {
        this.setState({
            isShowingGameOver: true,
            results
        });
    }

    render() {

        return (
            <Router>
                <div>
                    <Navbar/>
                    <Switch>
                        <Route path="/subscribe">
                            <SubscribePage/>
                        </Route>
                        <Route path="/game">
                            <GamePage/>
                        </Route>
                        <Route path="/">
                            <LandingPage/>
                        </Route>
                    </Switch>
                    <Footer/>
                </div>
            </Router>
        );
    }
}

export default App;
